export default __webpack_public_path__ + "static/media/640_private01-fr-web.1ab85880.png";